import { memo } from "react";
import { StoryBibleCtaCardChrome } from "@sudowrite/shared-chat";
import type { CTAAction } from "./ThinkingStep/cta-types";
import { getStoryBibleCtaProgressHeadline, getStoryBibleSectionIconForCta } from "./storyBibleCta";
import { useStoryBibleCtaDisplayProgress } from "./useStoryBibleCtaDisplayProgress";
import { storyBibleCardWebIcons, storyBibleSectionWebIcon } from "./planCardWebIcons";

type Props = {
  ctaAction: CTAAction;
  mode: "floating" | "inline";
  onCancel?: () => void;
};

export const StoryBibleCtaCard = memo(({ ctaAction, mode, onCancel }: Props) => {
  const { primary: title, secondary: traitSubtitle } = getStoryBibleCtaProgressHeadline(ctaAction);
  const isActive = ctaAction.status === "in_progress";
  const displayProgress = useStoryBibleCtaDisplayProgress(ctaAction);

  return (
    <StoryBibleCtaCardChrome
      title={title}
      traitSubtitle={traitSubtitle}
      mode={mode}
      displayProgress={displayProgress}
      isActive={isActive}
      sectionIcon={storyBibleSectionWebIcon(getStoryBibleSectionIconForCta(ctaAction.type))}
      frameIcon={storyBibleCardWebIcons.frame}
      stopIcon={storyBibleCardWebIcons.stop}
      onCancel={onCancel}
    />
  );
});
